import React from "react";
import NetlifyCmsWidgetMarkdown from "netlify-cms-widget-markdown";

const name = "rtlmarkdown";

const PreviewComponent = NetlifyCmsWidgetMarkdown.previewComponent;
const OrgControlComponent = NetlifyCmsWidgetMarkdown.controlComponent;

const ControlComponent = React.forwardRef((props, ref) => {
	return <div dir="rtl">
		<OrgControlComponent {...props} ref={ref} />
	</div>;
});

export default {
	name,
	ControlComponent,
	PreviewComponent,
};